<template>
  <h2 class="pb-2 border-bottom">Cuidados Primários Gerais</h2>
  <ul>
    <li>Consultas virtuais para doenças comuns (resfriado, gripe, alergias)</li>
    <li>Renovação de receitas e gestão de medicamentos</li>
    <li>Acompanhamento de doenças crônicas (diabetes, hipertensão, distúrbios da tireoide)</li>
    <li>Conselhos de saúde preventiva</li>
  </ul>

  <h2 class="pb-2 border-bottom">Perda de Peso e Saúde Metabólica</h2>
  <ul>
    <li>Consultas virtuais para prescrições de Ozempic e monitoramento</li>
    <li>Conselhos online sobre dieta e nutrição</li>
    <li>Tratamentos hormonais para perda de peso</li>
  </ul>

  <h2 class="pb-2 border-bottom">Saúde Masculina e Feminina</h2>
  <ul>
    <li>Acompanhamento de Terapia de Reposição Hormonal (TRH)</li>
    <li>Monitoramento de Terapia de Reposição de Testosterona (TRT)</li>
    <li>Gestão da menopausa e SOP</li>
  </ul>

  <h2 class="pb-2 border-bottom">Saúde Mental e Coaching de Estilo de Vida</h2>
  <ul>
    <li>Gestão de ansiedade e depressão</li>
  </ul>
</template>

<script>
export default {
  name: 'TelemedicineContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
